// extracted by mini-css-extract-plugin
export default {"zoomIcon":"anatomyEdit_zoomIcon__K88An","wrapperClass":"anatomyEdit_wrapperClass__3hYZS","iconHover":"anatomyEdit_iconHover__l+pQS"};